import { render } from "./j-message.vue?vue&type=template&id=644cb9d0&scoped=true"
import script from "./j-message.vue?vue&type=script&lang=js"
export * from "./j-message.vue?vue&type=script&lang=js"

import "./j-message.vue?vue&type=style&index=0&id=644cb9d0&scoped=true&lang=less"

import exportComponent from "/Users/jiangwen/GitHub/xiamao-mall/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-644cb9d0"]])

export default __exports__